import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Applications from './pages/Applications';
import { ThemeProvider } from './components/ThemeProvider';
import { useTranslation } from 'react-i18next';
import './i18n/config';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PageTitleUpdater() {
  const { t } = useTranslation();
  React.useEffect(() => {
    document.title = `Appfred | Alfredo Menéndez`;
  }, [t]);
  return null;
}

export default function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <PageTitleUpdater />
        <div className="min-h-screen flex flex-col bg-[#F7F8FA] dark:bg-[#0F172A] transition-colors duration-500">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/apps" element={<Applications />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}